// Reconstructed from production code; original paths and local names were not available.
import React from "react";
import * as jsxRuntime from "react/jsx-runtime";
const FiltersContext = React.createContext(null);
function FiltersProvider({ children: children }) {
  const [i, c] = React.useState(null),
    [s, d] = React.useState(null),
    f = {
      selectedCategory: i,
      selectedSubcategory: s,
      setSelectedCategory: c,
      setSelectedSubcategory: d,
      resetFilters: () => {
        c(null);
        d(null);
      },
    };
  return (
    <FiltersContext.Provider value={f}>{children}</FiltersContext.Provider>
  );
}
function useFilters() {
  const l = React.useContext(FiltersContext);
  if (!l) throw new Error("useFilters must be used within a FiltersProvider");
  return l;
}
export { FiltersContext, FiltersProvider, useFilters };
